import colors from 'bones/styles/colors.scss';

// this order matters!
export const queryBuilderColors = [
  { id: 'sd-qb-red', color: colors['sd-qb-red'] },
  { id: 'sd-qb-light-orange', color: colors['sd-qb-light-orange'] },
  { id: 'sd-qb-orange', color: colors['sd-qb-orange'] },
  { id: 'sd-qb-gold', color: colors['sd-qb-gold'] },
  { id: 'sd-qb-yellow-green', color: colors['sd-qb-yellow-green'] },
  { id: 'sd-qb-green', color: colors['sd-qb-green'] },
  { id: 'sd-qb-teal', color: colors['sd-qb-teal'] },
  { id: 'sd-qb-light-blue-1', color: colors['sd-qb-light-blue-1'] },
  { id: 'sd-qb-light-blue-2', color: colors['sd-qb-light-blue-2'] },
  { id: 'sd-qb-light-purple-1', color: colors['sd-qb-light-purple-1'] },
  { id: 'sd-qb-light-purple-2', color: colors['sd-qb-light-purple-2'] },
  { id: 'sd-qb-cream', color: colors['sd-qb-cream'] },
];
